import { render, staticRenderFns } from "./CompanyVerify.vue?vue&type=template&id=cb5e7c7e&scoped=true"
import script from "./CompanyVerify.vue?vue&type=script&lang=js"
export * from "./CompanyVerify.vue?vue&type=script&lang=js"
import style0 from "./CompanyVerify.vue?vue&type=style&index=0&id=cb5e7c7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5e7c7e",
  null
  
)

export default component.exports